/* app/js/src/components/content-control/studio/content-control-studio/shared-objects/zoom-in-icon/zoom-in-icon.component.scss */
:host {
  display: flex;
}
/*# sourceMappingURL=zoom-in-icon.component.css.map */
